import React from 'react';
import bg from '../../../Assets/services/Picture6.png';

import "./pages.css"

const AnkleBoot=()=> {
return (
<div className="row container-fluid mt-3 Pages-font-size">
  <div className="col-sm-4 justify-content-center">
  <img className="w-100 rounded mt-2" src={bg} alt=""/>
  </div>
  <div className="col-sm-8  mt-2 mb-5">
      <h1> ANKLE BOOT </h1>
      <p>
      This Ankle boot is designed to alleviate heel pain associated with Plantar Fascitis and Achilles tendonitis and to arrest the improper ankle movement and to maintain stability of ankle joints of the foot.This product can be also used as an alternate of custom orthotics like AFO and Foot Drop Splint. Insoles adjustment can be done to adjust the desired dorsiflexion of the foot. The antibacterial soft fabric lining absorbs moisture and ensure a cool,comfortable fit and a non-skid sole for minimum ambulation. A Large supporting surface provides enough space for optimal confort.
      </p>
   <ol> 
<li>Hard Backcountered Stiffner provides sufficient stability support of the footWedges can be added to create varying degrees of angle within the footbed </li>
<li>Fast and easy to use with a Velcro Fastener </li>
<li>Provides a sustained stretch to the plantar fascia </li>
<li>Postoperative immobilization </li>
<li>Prevention of Equines deformities </li>
</ol>  
 </div>
</div>
);
}


export default AnkleBoot;